module.exports = __webpack_public_path__ + "img/download2.dbb5c0f6.png";